module.exports = {
  "exploreReport": {
    "name": "REPORT_INTERACTION",
    "properties": {
      "action": "string",
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "class": "interaction"
  },
  "updateContext": {
    "name": "REPORT_INTERACTION",
    "properties": {
      "action": "string",
      "value": "string",
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "class": "interaction"
  },
  "exploreMultiplePageLinks": {
    "name": "REPORT_INTERACTION",
    "properties": {
      "action": "string",
      "type": "string",
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "class": "interaction"
  },
  "clickedPostPublish": {
    "name": "REPORT_INTERACTION",
    "properties": {
      "action": "string",
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "class": "interaction"
  },
  "chooseReportColumns": {
    "name": "REPORT_INTERACTION",
    "properties": {
      "action": "string",
      "appKey": "string",
      "option": "array",
      "metricKey": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "class": "interaction"
  },
  "changeEventType": {
    "name": "REPORT_INTERACTION",
    "properties": {
      "action": "string",
      "eventType": "string",
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "class": "interaction"
  },
  "onboarding": {
    "name": "ONBOARDING",
    "properties": {
      "action": "string",
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "class": "interaction"
  },
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "subscreen": "string",
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "navigateFromReporting": {
    "name": "REPORT_INTERACTION",
    "properties": {
      "action": "string",
      "isBeforeUnload": {
        "type": "boolean",
        "isOptional": true
      },
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "class": "interaction"
  },
  "export": {
    "name": "REPORT_INTERACTION",
    "properties": {
      "exportType": "string",
      "type": "string",
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "class": "interaction"
  },
  "exportAsList": {
    "name": "REPORT_INTERACTION",
    "properties": {
      "type": "string",
      "action": "string",
      "isNewList": "boolean",
      "metric": {
        "type": "string",
        "isOptional": true
      },
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "class": "interaction"
  },
  "paginateDrilldownTable": {
    "name": "REPORT_INTERACTION",
    "namespace": "reporting",
    "class": "interaction",
    "properties": {
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    }
  },
  "modalView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "subscreen2": "string",
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "analyticsToolActivation": {
    "name": "ACTIVATION_MILESTONE",
    "class": "activation",
    "properties": {
      "action": "string",
      "screen": "string",
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "analyticsToolDayZero": {
    "name": "ACTIVATION_MILESTONE",
    "class": "activation",
    "properties": {
      "action": "string",
      "screen": "string",
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting"
  },
  "userRetained": {
    "name": "REPORT_INTERACTION",
    "properties": {
      "action": "string",
      "tool": [
        "sources",
        "sales-productivity/deals",
        "sales-productivity/meetings",
        "sales-productivity/calls",
        "sales-productivity/tasks",
        "sales-productivity/emails"
      ],
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "class": "interaction"
  },
  "exitPage": {
    "name": "ANALYTICS_INTERACTION",
    "properties": {
      "action": "string",
      "screen": "string",
      "isBeforeUnload": {
        "type": "boolean",
        "isOptional": true
      },
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "class": "interaction"
  },
  "trackingUrl": {
    "name": "TRACKING_URL_INTERACTION",
    "properties": {
      "action": "string",
      "eventType": "string",
      "metricKey": {
        "type": "string",
        "isOptional": true
      },
      "appKey": {
        "type": "string",
        "isOptional": true
      },
      "option": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "class": "interaction"
  }
};